import { jsx as _jsx } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/tooltip.scss';
import { Tooltip } from 'react-tooltip';
import { TooltipBehavior } from './TooltipTypes';
export const TooltipClick = () => {
    return (_jsx(Tooltip, { id: TooltipBehavior.Click, offset: 5, openOnClick: true, closeEvents: { mouseleave: true, blur: true, click: true } }));
};
